<template>
  <div class="navbar">
    <div class="navbar-left">
      <TagsView class="tags-view-container" />
    </div>
    <div class="cmd-trigger-wrap">
      <button type="button" class="cmd-trigger m-groove" @click="commandOpen = true">
        <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <span class="cmd-text">搜索页面或指令...</span>
        <span class="kbd">⌘K</span>
      </button>
    </div>
    <div class="right-menu">
      <div class="right-menu-item hover-effect theme-toggle-btn" @click="toggleTheme" :title="isDark ? '切换浅色模式' : '切换深色模式'">
        <el-icon class="font-18">
          <Sunny v-if="isDark" />
          <Moon v-else />
        </el-icon>
      </div>
      <div class="right-menu-item hover-effect" @click="goToNotification">
        <el-badge :value="unreadCount" :hidden="unreadCount <= 0" :max="99">
          <el-icon class="font-20"><Bell /></el-icon>
        </el-badge>
      </div>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="hover"
      >
        <div class="avatar-wrapper cursor">
          <svg
            class="icon user-avatar font-20"
            aria-hidden="true"
          >
            <use xlink:href="#icon-touxiang" />
          </svg>
          <span class="ml-10">{{name}}</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" class="icon"><path fill="currentColor" d="m192 384 320 384 320-384z"></path></svg>
        </div>
        <template #dropdown>
          <el-dropdown-menu >
            <el-dropdown-item @click="changePassword">
              {{ t("navbar.changePassword") }}
            </el-dropdown-item>
            <el-dropdown-item @click="goToNotification">
              消息
            </el-dropdown-item>
            <el-dropdown-item
              divided
              @click="logout"
            >
              <span style="display:block;">
                {{ t("navbar.logOut") }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog
      v-model="dialogVisible"
      title="修改密码"
      width="30%"
    >
    <el-form
      ref="dataForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="旧密码" prop="currentPassword" :error="rules.currentPassword[0].message">
        <el-input
          v-model="ruleForm.currentPassword"
          autocomplete="new-password"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword" :error="rules.newPassword[0].message">
        <el-input
          v-model="ruleForm.newPassword"
          type="password"
          clearable
          autocomplete="new-password"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmNewPassword" :error="rules.confirmNewPassword[0].message">
        <el-input
          v-model="ruleForm.confirmNewPassword"
          type="password"
          clearable
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger">取消</el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >确定</el-button>
      </span>
    </template>
  </el-dialog>
  <CommandPalette :open="commandOpen" @close="commandOpen = false" @action="handleCommandAction" />
  </div>
</template>

<script>
import TagsView from '../tags_view/Index.vue'
import CommandPalette from '../CommandPalette.vue'

import { computed, reactive, toRefs, ref, unref, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from '@/store'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { useI18n } from 'vue-i18n'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { useRouter } from 'vue-router'
import { ElMessage, ElForm } from 'element-plus'
import { changePassword } from '@/apis/user'

export default {
  components: {
    TagsView,
    CommandPalette
  },
  setup() {
    const commandOpen = ref(false)
    const isDark = ref(typeof document !== 'undefined' && document.documentElement.dataset.theme === 'dark')

    const toggleTheme = () => {
      const next = isDark.value ? 'light' : 'dark'
      document.documentElement.dataset.theme = next
      try { localStorage.setItem('erp.theme', next) } catch (e) {}
      isDark.value = next === 'dark'
    }

    const onGlobalKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        commandOpen.value = !commandOpen.value
      }
    }

    onMounted(() => {
      try {
        const saved = localStorage.getItem('erp.theme')
        if (saved) {
          document.documentElement.dataset.theme = saved
          isDark.value = saved === 'dark'
        }
      } catch (e) {}
      document.addEventListener('keydown', onGlobalKey)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('keydown', onGlobalKey)
    })

    const handleCommandAction = (action) => {
      if (action === 'logout') {
        state.logout()
      } else if (action === 'change-password') {
        state.changePassword()
      }
    }
    const dataForm = ref(ElForm)
    const store = useStore()
    const router = useRouter()
    const { t } = useI18n()
    const sidebar = computed(() => {
      return store.state.app.sidebar
    })
    const device = computed(() => {
      return store.state.app.device.toString()
    })
    const avatar = computed(() => {
      return store.state.user.avatar
    })
        const name = computed(() => {
      return store.state.user.name
    })
    const unreadCount = computed(() => {
      return store.state.notification.unreadCount
    })
    const state = reactive({
      dialogVisible: false,
      ruleForm: {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      rules: {
        currentPassword: [{ required: true, message: '', trigger: ['change', 'blur'] }],
        newPassword: [{ required: true, message: '', trigger: ['change', 'blur'] }],
        confirmNewPassword: [{ required: true, message: '', trigger: ['change', 'blur'] }]
      },

      toggleSideBar: () => {
        store.dispatch(AppActionTypes.ACTION_TOGGLE_SIDEBAR, false)
      },
      logout: () => {
        useStore().dispatch(UserActionTypes.ACTION_LOGIN_OUT)
        router.push('/login').catch(err => {
          console.warn(err)
        })
      },
      goToNotification() {
        router.push('/notification')
      },
      changePassword() {
        state.dialogVisible = true
      },
      handleConfirm() {
        const form = unref(dataForm)
        form.validate((valid) => {
          if (valid) {
            if (state.ruleForm.newPassword !== state.ruleForm.confirmNewPassword) {
              ElMessage.error('两次输入密码不一致请重新输入！')
              state.ruleForm.confirmNewPassword = ''
              state.ruleForm.newPassword = ''
            } else {
              const { currentPassword, newPassword, confirmNewPassword } = state.ruleForm
              changePassword({
                currentPassword, newPassword, confirmNewPassword
              }).then(() => {
                state.dialogVisible = false

                state.ruleForm = {
                  currentPassword: '',
                  newPassword: '',
                  confirmNewPassword: ''
                }
                ElMessage.success('修改成功！')
              }).catch((err) => {
                err.errors.forEach(item => {
                  state.rules[item.field][0].message = null
                  nextTick(() => {
                    state.rules[item.field][0].message = item.defaultMessage
                  })
                })
              })
            }
          }
        })
      }
    })

    return {
      unreadCount,
      sidebar,
      device,
      avatar,
      name,
      ...toRefs(state),
      t,
      dataForm,
      commandOpen,
      toggleTheme,
      isDark,
      handleCommandAction
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  position: relative;
  background: var(--rail-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 8px solid var(--stage-gutter, #f5f5f5);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;

  .cmd-trigger-wrap {
    display: flex;
    align-items: center;
    margin: 0 16px;
  }

  .cmd-trigger {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 220px;
    height: 32px;
    padding: 0 10px;
    border-radius: var(--r-sm);
    font-size: 12px;
    color: var(--ink-faint);
    background: var(--groove-bg);
    border: 1px solid var(--line);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--blue);
      color: var(--ink-muted);
    }

    .cmd-text {
      flex: 1;
      text-align: left;
    }

    .kbd {
      padding: 1px 5px;
      border-radius: 4px;
      background: var(--pill-bg);
      border: 1px solid var(--line);
      color: var(--ink-soft);
      font-size: 10px;
      font-family: var(--font-mono);
    }
  }

  .theme-toggle-btn {
    margin-right: 6px;
    color: var(--ink-soft);
    &:hover {
      color: var(--blue);
    }
  }

  .navbar-left {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
  }

  .right-menu {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: 100%;

    .right-menu-item {
      display: flex;
      align-items: center;
      padding: 0 8px;
      height: 100%;
      font-size: 14px;
      color: #5a5e66;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        &:hover { background: rgba(0, 0, 0, 0.025); }
      }
    }
    
    :deep(.el-badge) {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .avatar-container {
      .avatar-wrapper {
        display: flex;
        align-items: center;
        margin-right: 16px;
        margin-left: 16px;
        position: relative;
        .user-avatar { cursor: pointer; }
      }
    }
  }
}
</style>
